<template>

<ion-alert
        :is-open="isOpen"
        :header="alertHeader"
        :message="alertMessage"
        :buttons="alertButtons"
        @didDismiss="setOpen(false)"
    >
    </ion-alert>

</template>

<script setup>

  import { IonAlert, modalController } from '@ionic/vue';

  import { ref } from "vue"
  import { watch } from "vue";
  import { computed } from "@vue/reactivity"
  import { t } from '@/composables/translateText.js'

  const emit = defineEmits(['alert-result'])

  const props = defineProps({
    alertInfo : {
      type : Object,
      default : { header : "Test", 
              message : "This is a dummy message", type : "yesno" , task : "test"}
    },
    payload : {
      type : Object,
      default : {}
    },
    trigger : Number
  })
 
  const trigger = computed({ get() { return props.trigger } })

  const isOpen = ref(false);
  const alertHeader = ref("Header")
  const alertMessage = ref("Message")
  
  const alertFenPGNButtons = [
    {
      text: t('Cancel'),
      role: 'cancel',
      handler: () => {
        alertCancel()
      },
    },
    {
      text: t('Current Fen'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("fen")
      },
    },
    {
      text: t('Entire PGN'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("pgn")
      },
    }
  ]

  const alertCopyBoardMovesButtons = [
    {
      text: t('Cancel'),
      role: 'cancel',
      handler: () => {
        alertCancel()
      },
    },
    {
      text: t('Current Board (FEN)'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("fen")
      },
    },
    {
      text: t('Entire Move Sequence (PGN)'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("pgn")
      },
    }
  ]

  const alertWhiteBlackButtons = [
    {
      text: t('Cancel'),
      role: 'cancel',
      handler: () => {
        alertCancel()
      },
    },
    {
      text: t('White'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("white")
      },
    },
    {
      text: t('Black'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("black")
      },
    }
  ]

  const alertYesNoButtons = [
    {
      text: t('NO'),
      role: 'cancel',
      handler: () => {
        alertCancel()
      },
    },
    {
      text: t('YES'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("yes")
      },
    }
  ]

  const alertOkButton = [
    {
      text: t('OK'),
      role: 'cancel',
      handler: () => {
        alertCancel()
      },
    }
  ]

  const alertBoardSourceButtons = [
    {
      text: t('Cancel'),
      role: 'cancel',
      handler: () => {
        alertCancel()
      },
    },
    {
      text: t('Initial Board'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("initial")
      },
    },
    {
      text: t('Empty Board'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("empty")
      },
    },
    {
      text: t('Paste FEN from Clipboard'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("paste")
      },
    },
  ]

  const alertMasterDownloadButtons = [
    {
      text: t('Cancel'),
      role: 'cancel',
      handler: () => {
        alertCancel()
      },
    },
    {
      text: t('Current Game'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("current")
      },
    },
    {
      text: t('All Games'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("all")
      },
    },
    {
      text: t('Fen to Clipboard'),
      role: 'confirm',
      handler: () => {
        alertConfirmed("fen")
      },
    }
  ]

  var alertButtons = alertYesNoButtons

  const setOpen = (state) => {
    isOpen.value = state;
  };

  watch(trigger, (newVal,oldVal) => {
    //console.log("**** alert replacement trigger",newVal)
    setupAlert()
  })

  function setupAlert() {
    switch (props.alertInfo.type) {
      default :
      case "alert" :
      case "error" :
        alertButtons = alertOkButton
        break
      case "boardmoves" :
        alertButtons = alertCopyBoardMovesButtons
        break
      case "fenpgn" :
        alertButtons = alertFenPGNButtons
        break
      case "whiteblack" :
        alertButtons = alertWhiteBlackButtons
        break
      case "yesno" :
        alertButtons = alertYesNoButtons
        break
      case "boardsource" :
        alertButtons = alertBoardSourceButtons
        break
      case "masterdownload" :
        alertButtons = alertMasterDownloadButtons
        break
    }
    alertHeader.value = props.alertInfo.header
    alertMessage.value = props.alertInfo.message
    isOpen.value = true
  }

  function alertCancel() {
    //console.log('Alert canceled',props.alertInfo.task);
    emit('alert-result',"no",props.alertInfo.task,props.alertInfo)
  }

  function alertConfirmed(text) {
    //console.log('Alert confirmed',text,props.alertInfo.task)
    emit('alert-result',text,props.alertInfo.task,props.alertInfo)
  }

</script>

<style scoped>

</style>